// extracted by mini-css-extract-plugin
export default {"thumb":"aUEr3hcsRqzUmlvIeKHl"};